export default "__VITE_ASSET__Ccjy5EI___"